export const initialBrowserStoreState = {
  isOnline: window.navigator.onLine,
  isMobileUser: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
  isMobileScreen: window.matchMedia("(max-width: 767px)").matches,
};
